import ExecutiveOverview from '../features/analytics/ExecutiveOverview';
import DailyIncomeChart from '../features/analytics/DailyIncomeChart';
import TopSellersLeaderboard from '../features/analytics/TopSellersLeaderboard';
import ProductEngagementCard from '../features/analytics/ProductEngagementCard';

export default function DashboardHome() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Yönetici Paneli</h1>
          <p>Geliri, operasyon yoğunluğunu ve ürün performansını tüm şubeler için tek ekrandan takip edin.</p>
        </div>
      </header>

      <section className="page-section">
        <ExecutiveOverview />
        <DailyIncomeChart />
        <TopSellersLeaderboard />
        <ProductEngagementCard />
      </section>
    </div>
  );
}
